// Input validation on change
// Checks input validity when input loses focus. Ideally for
// use when errors are visible and user is validating them.
// ----------------------------------------------------------------

import $ from 'jquery';
import { inputValidationFunction } from './input-validation-function';

import { updateTriggerOnClickFunctionalityWithPlausibleProps } from './handle-updating-donation-form-trigger-with-plausible-props';

function inputValidationOnChange() {

    // Gets all inputs.
    // Note: Doesn't get required inputs specifically as not all radio
    // buttons or checkboxes are required.
    var inputs = $('fieldset').find('input');

    $(inputs).on('change', function() {

      // console.log(inputs);
      // console.log(this);
      // let fieldset = $(this).closest('fieldset');
      updateTriggerOnClickFunctionalityWithPlausibleProps();


        // If radio button or checkbox.
        // Finds error field under input.
        if ($(this).closest('.js-checkedStateTarget').next('.js-formErrorMessage').is(':visible')) {

            // Calls validation function.
            inputValidationFunction($(this));

        // If anything besides radio button or checkbox is being validated.
        } else if ($(this).closest('div').find('.js-formErrorMessage').is(':visible')) {

            // Calls validation function.
            inputValidationFunction($(this));

        }

    });
}
inputValidationOnChange();
